/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLastOpenShiftMovements200ResponseMovementsInner
 */
export interface GetLastOpenShiftMovements200ResponseMovementsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    method?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    creationTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    diff?: number;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    detail?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLastOpenShiftMovements200ResponseMovementsInner
     */
    tableName?: string;
}

/**
 * Check if a given object implements the GetLastOpenShiftMovements200ResponseMovementsInner interface.
 */
export function instanceOfGetLastOpenShiftMovements200ResponseMovementsInner(value: object): value is GetLastOpenShiftMovements200ResponseMovementsInner {
    return true;
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerFromJSON(json: any): GetLastOpenShiftMovements200ResponseMovementsInner {
    return GetLastOpenShiftMovements200ResponseMovementsInnerFromJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastOpenShiftMovements200ResponseMovementsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'method': json['method'] == null ? undefined : json['method'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'diff': json['diff'] == null ? undefined : json['diff'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'tableName': json['tableName'] == null ? undefined : json['tableName'],
    };
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerToJSON(json: any): GetLastOpenShiftMovements200ResponseMovementsInner {
    return GetLastOpenShiftMovements200ResponseMovementsInnerToJSONTyped(json, false);
}

export function GetLastOpenShiftMovements200ResponseMovementsInnerToJSONTyped(value?: GetLastOpenShiftMovements200ResponseMovementsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': value['method'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'diff': value['diff'],
        'detail': value['detail'],
        'tableName': value['tableName'],
    };
}

